import Vue from "vue";
import App from "@/App.vue";
import axios from "axios";
import router from "@/router";
import store from "@/store";
import VueMeta from "vue-meta";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faAngleDown,
  faAngleRight,
  faBars,
  faFileAlt,
  faThLarge,
  faFile,
  faUser,
  faLock,
  faMinus,
  faAngleUp,
  faCalendarAlt,
  faPlusSquare,
  faTasks,
  faSearch,
  faCogs,
  faSignOutAlt,
  faThList,
  faTachometerAlt,
  faEye,
  faTrash,
  faSort,
  faAlignJustify,
  faChevronDown,
  faChevronUp,
  faUserCog,
  faSave
} from "@fortawesome/free-solid-svg-icons";
import "./utils/init-font-icons";
import "./utils/init-toast";
import "./utils/init-validation";
import "./utils/http-configs";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";

import "devextreme/dist/css/dx.light.css";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "vue2-datepicker/locale/vi";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Tree from "primevue/tree";
import DataTable from "primevue/datatable";
import RadioButton from "primevue/radiobutton";
import Checkbox from "primevue/checkbox";

import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import VueFileAgent from "vue-file-agent";
import VueFileAgentStyles from "vue-file-agent/dist/vue-file-agent.css";
import BaseButton from "@/components/common/BaseButton";
import InputText from "primevue/inputtext";
import "vue-multiselect/dist/vue-multiselect.min.css";
import MultiSelect from "primevue/multiselect";
import OtpInput from "@bachdgvn/vue-otp-input";
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

Vue.component("v-otp-input", OtpInput);
Vue.component("Column", Column);
Vue.component("ColumnGroup", ColumnGroup);
Vue.component("Tree", Tree);
Vue.component("DataTable", DataTable);
Vue.component("RadioButton", RadioButton);
Vue.component("Checkbox", Checkbox);
Vue.component("InputText", InputText);
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
import "./utils/filters";

Vue.use(Loading)
Vue.component("loading-overlay", Loading);
Vue.component("date-picker", DatePicker);
library.add(
  faUserSecret,
  faThLarge,
  faAngleDown,
  faAngleRight,
  faBars,
  faFileAlt,
  faFile,
  faUser,
  faLock,
  faAngleUp,
  faCalendarAlt,
  faPlusSquare,
  faTasks,
  faSearch,
  faCogs,
  faSignOutAlt,
  faThList,
  faTachometerAlt,
  faEye,
  faTrash,
  faSort,
  faMinus,
  faAlignJustify,
  faChevronDown,
  faChevronUp,
  faUserCog,
  faSave
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("v-select", vSelect);
Vue.component("base-button", BaseButton);
Vue.component("DataTable", DataTable);
Vue.component("MultiSelect", MultiSelect);
Vue.use(VueFileAgent);
Vue.use(VueFileAgentStyles);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});
axios.defaults.headers.post["Content-Type"] = "application/json";
Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router,
  store
}).$mount("#app");
